import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Questions, SelectedOptionList } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { PreviewData } from 'src/app/common-class/survey';
declare let $: any;

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.css'],
})
export class RankingComponent implements OnInit {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isMobile: boolean;
  @Input() Rank: string;
  @Input() isNewParticipationButton: boolean;
  @Input() isResponseUpdate: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  questionswithoutRank: Questions;
  questionswithRank: Questions;
  rankArray: any = [];
  constraint: any;
  this: this;

  selectedValueList: SelectedOptionList[] = [];
  imageWidth: string;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  surveyFormat: number;
  isNewParticipation: boolean;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAriaRequired: boolean;
  isAnsChange: boolean = false;
  isDisplayedPipeMessage: boolean;
  resetPageSub: any;
  isResetPage: boolean = false;
  isEditPostPop: boolean = false;

  constructor(
    private service: ParticipationDataService,
    private previewData: PreviewData,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['JsonData'];

    if (change != undefined) {
      const curVal = JSON.stringify(change.currentValue);
      const preVal = JSON.stringify(change.previousValue);
      const ques = JSON.parse(this.JsonData);
      if (curVal != preVal && preVal != undefined && (this.isResetPage || ques.IsADLRuleApplied)) {
        this.questions = ques;
        this.answerPipingMessageDisplayed();
        this.isResetPage = false;
        if (ques.IsADLRuleApplied) {
          this.constraint = this.questions.rank_limit;

          if (this.constraint == 0) {
            const ans = this.questions.Answers.filter(
              (e) => !e.isHide && !e.isADLHide,
            );
            this.constraint = ans.length;
          }
          this.rankArray = [];
          this.rankArray[0] = '-' + this.Rank + '-';
          for (let i = 1; i <= this.constraint; i++) {
            this.rankArray[i] = i;
          }
          if (this.questions.selectedOptionList != null) {
            this.selectedValueList = this.questions.selectedOptionList;
          }
        }
        for (const answer of this.questions.Answers) {
          if (
            answer.ControlAns == null ||
            answer.ControlAns == undefined
          ) {
            let ansInd = this.questions.Answers.findIndex((e) => e.value_id == answer.value_id);
            this.questions.Answers[ansInd].ControlAns = '-' + this.Rank + '-';
          }
        }
        this.validateQuestionSelection(this.questions);
      }
    }
  }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
      this.answerPipingMessageDisplayed();
    }
      this.isEditPostPop = this.service.getisEditPostPop();
    this.constraint = this.questions.rank_limit;

    if (this.constraint == 0) {
      const ans = this.questions.Answers.filter((e) => !e.isHide && !e.isADLHide);
      this.constraint = ans.length;
    }

    if (this.questions.selectedOptionList != null) {
      this.selectedValueList = this.questions.selectedOptionList;
    }

    if (this.questions.AnswerText != null) {
      for (const answer of this.questions.Answers) {
        if (
          answer.ControlAns == null ||
          answer.ControlAns == undefined
        ) {
          let ansInd = this.questions.Answers.findIndex((e) => e.value_id == answer.value_id);
          this.questions.Answers[ansInd].ControlAns = '-' + this.Rank + '-';
        } else {
          let selectedValue = this.selectedValueList.find(
            (e) => e.value_id == answer.value_id,
          );
          if (selectedValue != null) {
            let ansInd = this.questions.Answers.findIndex((e) => e.value_id == answer.value_id);
            this.questions.Answers[ansInd].ControlAns = selectedValue.value_text;

            if (this.questions.Answers[ansInd].ControlAns != '-' + this.Rank + '-') {
              if (parseInt(this.questions.Answers[ansInd].ControlAns) > this.constraint) {
                this.questions.Answers[ansInd].ControlAns = '-' + this.Rank + '-';
                this.selectedValueList.splice(this.selectedValueList.indexOf(selectedValue), 1);
                this.questions.selectedOptionList = this.selectedValueList;

                if (
                  this.questions.selectedOptionList.length > 0 &&
                  this.questions.Answers.length > this.questions.selectedOptionList.length
                ) {
                  this.questions.isValid = true;
                  this.questions.isAlertDanger = true;
                }
                this.ChangeAnswersData.emit(this.questions);
              }
            }
          }
        }
      }
      this.questions.Answers.sort((val, val2) => val.ControlAns - val2.ControlAns);
    } else {
      for (const answer of this.questions.Answers) {
        if (
          answer.ControlAns == null ||
          answer.ControlAns == undefined
        ) {
          let ansInd = this.questions.Answers.findIndex((e) => e.value_id == answer.value_id);
          this.questions.Answers[ansInd].ControlAns = '-' + this.Rank + '-';
        }
      }
    }

    this.rankArray[0] = '-' + this.Rank + '-';
    for (let i = 1; i <= this.constraint; i++) {
      this.rankArray[i] = i;
    }

    this.questionswithoutRank = Object.assign([], this.questions);
    this.questionswithRank = Object.assign([], this.questions);

    this.questionswithoutRank.Answers = this.questions.Answers.filter(
      (h) => h.ControlAns !== '-' + this.Rank + '-',
    );
    this.questionswithRank.Answers = this.questions.Answers.filter(
      (h) => h.ControlAns == '-' + this.Rank + '-',
    );

    if (this.questionswithRank.Answers.length > 0 && this.questionswithoutRank.Answers.length > 0) {
      this.questionswithoutRank.Answers.sort((n1, n2) => n1.ControlAns - n2.ControlAns);
      this.questions.Answers = this.questionswithoutRank.Answers.concat(
        this.questionswithRank.Answers,
      );
    } else {
      this.questions.Answers.sort((n1, n2) => n1.ControlAns - n2.ControlAns);
    }

    if (this.questions.answer_style == 1 && this.questions.Answers != null) {
      this.questions.Answers = CommonLogic.RandomAnswerHandling(this.questions);
    }

        this.validateQuestionSelection(this.questions);
    this.ChangeAnswersData.emit(this.questions);

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';

    this.surveyFormat = this.service.surveyFormat;
    this.isNewParticipation = this.service.isNewParticipation;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton = this.isNewParticipationButton;

    this.isAriaRequired =
      (this.questions.mandatory && this.isMandatoryUpfront) ||
      (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
  }

  ngAfterViewInit() {
    let oldRank;
    let placeholderIndex = 0;
    let sortValue = this.SortValue;
    let self = this;

    let tolarance;
    let handle;

    if (this.isMobile) {
      tolarance = 'Intersect';
      handle = '.dv-rank-handle';
    } else {
      tolarance = 'pointer';
      handle = '';
    }

    let id = 'ul_Q' + this.questions.qno + '_' + this.questions.UniqueNumber;

    let isUpdatingRank = false;
    let debounceTimer; 
    let rankConstraint = 0;

    $('#' + id).sortable({
        tolerance: tolarance,
        axis: "y",
        handle: handle,
        containment: '#rank-wrapper_' + this.questions.qno + '_' + this.questions.UniqueNumber,
        start: function (event, ui) {
            let rankConstraint = $(this).attr('constraintLimit');
            if (rankConstraint == 0) {
                rankConstraint = $(this)
                    .find('.rank-option')
                    .not('li:hidden')
                    .not('.ui-sortable-placeholder').length;
            }
        },
        sort: function (event, ui) {
            ui.placeholder.height(ui.item.outerHeight() + 5);
            placeholderIndex = ui.placeholder.index();
        },
        change: function (event, ui) {
            if (isUpdatingRank) return;
              isUpdatingRank = true;
            let isRanked = true;
            setTimeout(() => {
                this.isAnsChange = true;
            }, 500);
            rankConstraint = $(this).attr('constraintLimit');
            if (rankConstraint == 0) {
                rankConstraint = $(this)
                    .find('.rank-option')
                    .not('li:hidden')
                    .not('.ui-sortable-placeholder').length;
            }
            $(this)
                .find('.rank-option')
                .not('li:hidden')
                .not('.ui-sortable-placeholder')
                .each(function (i) {
                    if (isNaN(parseInt($(this).find('select').val()))) {
                        isRanked = false;
                    }
                });
              if (!isRanked) {
                $(this)
                    .find('.rank-option')
                    .not('li:hidden')
                    .not('.ui-sortable-placeholder')
                    .each(function (i) {
                        if (i < rankConstraint) {
                            $(this)
                                .find('select')
                                .val(i + 1);
                        } else {
                            $(this)
                                .find('select')
                                .val('-' + self.Rank + '-');
                        }
                    });
                }

            let swapItemVal;
            if (ui.placeholder.index() > placeholderIndex) {
                // Moving down
                placeholderIndex = ui.placeholder.index();
                swapItemVal = ui.placeholder.prev('.rank-option').not('li:hidden').find('select').val();
                ui.placeholder
                    .prev('.rank-option')
                    .not('li:hidden')
                    .find('select')
                    .val(ui.item.find('select').val());
            } else {
                // Moving up
                placeholderIndex = ui.placeholder.index();
                swapItemVal = ui.placeholder.next('.rank-option').not('li:hidden').find('select').val();
                ui.placeholder
                    .next('.rank-option')
                    .not('li:hidden')
                    .find('select')
                    .val(ui.item.find('select').val());
            }
            ui.item.find('select').val(swapItemVal);
            self.ChangeAnswersData.emit(self.questions);
            setTimeout(() => {
                isUpdatingRank = false;
            }, 100);
        },
        stop: function (event, ui) {
          clearTimeout(debounceTimer);
      
          debounceTimer = setTimeout(() => {
              $(this)
                  .find('.rank-option')
                  .not('li:hidden')
                  .each(function (i) {
                      let rankValue;
                      if (i < rankConstraint) {
                          rankValue = i + 1; 
                      } else {
                          rankValue = '-' + self.Rank + '-';
                      }
                      $(this).find('select').val(rankValue);
                      sortValue($(this).find('select').attr('value'), $(this).find('select').val(), self);
                  });
      
              self.ChangeAnswersData.emit(self.questions);
          }, 200);
        },
    });
    $('body').on('change', '.rankDropDown', function () {
      let currentParent;
      let currentConstraint = parseInt(
        $(this)
          .parents('#' + id)
          .attr('constraintlimit'),
      );
      if (currentConstraint == 0) {
        currentConstraint = $(this)
          .parents('#' + id)
          .find('.rank-option')
          .not('li:hidden').length;
      }
      let currentVal = $(this).val();
      let currentEl = $(this);
      currentVal = parseInt(currentVal);
      let strParentUI = $(this).parents('#' + id);
      $(strParentUI)
        .find('.rankDropDown')
        .not('li:hidden')
        .each(function () {
          if (
            this.options[this.selectedIndex].value != '' &&
            this.options[this.selectedIndex].value == currentVal &&
            this.id != currentEl.attr('id')
          ) {
            if ($(this).val() != '-' + self.Rank + '-') {
              $(this).val('-' + self.Rank + '-');
            }
          }
          sortValue($(this).attr('value'), $(this).val(), self);
        });
      self.service.setQuestionChange(self.questions);
      self.ChangeAnswersData.emit(self.questions);
    });
    if ($('#' + id).find('.oneImageRank').length > 0) {
      if ($('#' + id).find('.twoImageRank').length > 0) {
        this.imageWidth = 'twoImageWidth';
      } else {
        this.imageWidth = 'oneImageWidth';
      }
    } else if ($('#' + id).find('.twoImageRank').length > 0) {
      this.imageWidth = 'twoImageWidth';
    } else {
      this.imageWidth = '';
    }
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
        this.isResetPage = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.isFormSubmitSub) {
      this.isFormSubmitSub.unsubscribe();
    }
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  answerPipingMessageDisplayed() {
    if (
      this.previewData != undefined &&
      this.service.getPrevPgChnge() &&
      this.questions.AnsPipeCondition != 0 &&
      this.questions.AnsPipeCondition != 1 &&
      this.questions.AnsPipeCondition != 3 &&
      this.questions.AnsPipeCondition != 4
    ) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
  }

  SortValue(valueId: any, curVal, self) {
    let ans = self.questions.Answers.find((e) => e.value_id == valueId);

    if (ans != null && ans != undefined) {
      self.SelectedValue(ans, curVal, self);
    }
  }

  SelectedValue(answer: Answers, curVal: any, self) {
    this.isAnsChange = true;
    let updateItem = self.questions.Answers.find(self.findIndexToUpdate, answer);
    let index = self.questions.Answers.indexOf(updateItem);

    if (curVal != '-' + this.Rank + '-') {
      self.AddSelectedValueList(answer, curVal);

      answer.ControlAns = curVal;
      self.questions.Answers[index] = answer;
      self.questions.pageto = answer.pageto;
      self.questions.otherAnswer = null;

      self.questions.selectedOptionList = self.selectedValueList;

      if (self.questions.isSoftRequired) {
        self.questions.isSoftRequiredHandle = true;
      }
    } else {
      self.RemoveSelectedList(answer);
      answer.ControlAns = '-' + this.Rank + '-';
      self.questions.selectedOptionList = self.selectedValueList;
    }

this.validateQuestionSelection(this.questions);

    if (self.selectedValueList.length > 0) {
      self.questions.AnswerText = 'Selected Answer Option';
    } else {
      self.questions.AnswerText = null;
    }

    if (self.selectedValueList.length > 0) {
      let isOther = self.selectedValueList.find((e) => e.isOther);
      if (isOther != null && isOther != undefined) {
        self.questions.isOtherAnswer = true;
      } else {
        self.questions.isOtherAnswer = false;
        self.questions.otherAnswer = null;
      }
    }
  }

  AddSelectedValueList(answer: Answers, selectedValue: string) {
    let selectedList = this.selectedValueList.find((e) => e.value_id == answer.value_id);

    if (this.selectedValueList.indexOf(selectedList) < 0) {
      this.selectedValueList.push({
        value_id: answer.value_id,
        value_text: selectedValue,
        isOther: answer.isOther,
      });
    } else {
      this.RemoveSelectedList(answer);

      this.AddSelectedValueList(answer, selectedValue);
    }
  }

  RemoveSelectedList(answer: Answers) {
    let selectedList = this.selectedValueList.find((e) => e.value_id == answer.value_id);

    let curIndex = this.selectedValueList.indexOf(selectedList);

    if (curIndex >= 0) {
      this.selectedValueList.splice(curIndex, 1);
    }
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  getAnsImageMediaCSS(answer: Answers) {
    if (
      (answer.hasImage && answer.AnswerImages.length == 1 && !answer.hasMedia) ||
      (answer.hasMedia && answer.AnswerMedias.length == 1 && !answer.hasImage)
    ) {
      return 'oneImageRank';
    } else if (
      answer.hasImage &&
      answer.AnswerImages.length == 1 &&
      answer.hasMedia &&
      answer.AnswerMedias.length == 1
    ) {
      return 'twoImageRank';
    } else if (
      (answer.hasImage && answer.AnswerImages.length == 2) ||
      (answer.hasMedia && answer.AnswerMedias.length == 2)
    ) {
      return 'twoImageRank';
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    if (!question.isValid) {
      this.service.gotoNextQuestion(question, event);
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  getAnswerPipeMessage(): string {
    return this.service.getAnswerPipeMessage();
  }

    validateQuestionSelection(questions: any): void {
  if (questions?.rank_limit > 0 && questions?.selectedOptionList?.length > 0) {
    if (questions?.rank_limit !== questions?.selectedOptionList?.length) {
      questions.isValid = true;
      questions.isAlertDanger = true;
    } else {
      questions.isValid = false;
      questions.isAlertDanger = false;
    }
  } else if (
    questions?.selectedOptionList?.length > 0 &&
    questions?.Answers.filter((e) => e.isADLHide === false).length !==
      questions?.selectedOptionList?.length
  ) {
    questions.isValid = true;
    questions.isAlertDanger = true;
  } else {
    questions.isValid = false;
    questions.isAlertDanger = false;
  }
}
}
